import React, { useEffect, useState } from 'react'
import useAxiosPrivate from '../../hooks/use-axios-private'
import { Alert, AlertTitle, Box, CircularProgress, Grid, Typography } from '@mui/material'
import { BraintreePayPalButtons, PayPalScriptProvider, usePayPalScriptReducer } from '@paypal/react-paypal-js'
import { useTheme } from '@emotion/react'
import { PAYPAL_CLIENT_KEY } from '../../constants'
import { alertMsg } from '../../utils/basicUtils'
import useAuth from '../../hooks/use-auth'
import { authActions } from '../../redux/reducers/auth-slice'
import { useSearchParams } from 'react-router-dom'

import { useRef } from 'react'
import { useDispatch } from 'react-redux'
import moment from 'moment'
// This values are the props in the UI
const style = { "label": "paypal", "layout": "vertical" };
const amount = "2";

// Custom component to wrap the PayPalButtons and handle currency changes
const ButtonWrapper = ({ currency, token, paymentAmount, onError }) => {
    const axios = useAxiosPrivate()
    // usePayPalScriptReducer can be use only inside children of PayPalScriptProviders
    // This is the main reason to wrap the PayPalButtons in a new component
    const [{ options, isPending }, dispatch] = usePayPalScriptReducer();

    useEffect(() => {
        dispatch({
            type: "resetOptions",
            value: {
                ...options,
                currency: currency,
            },
        });
    }, [currency]);



    const createOrder = (data, actions) => {
        return actions.braintree.createPayment({
            flow: "checkout",
            amount: paymentAmount,
            currency: 'USD',
            intent: "capture",
        });
    }

    const onApproveHandler = (data, actions) => {
        return actions.braintree
            .tokenizePayment(data)
            .then((payload) => {
                return new Promise(async (resolve, reject) => {
                    try {
                        const resp = await axios.post("/payments/purchase/",
                            {
                                payment_method_nonce: payload.nonce,
                                device_data: "",
                                amount: paymentAmount
                            },
                            {
                                withCredentials: true,
                                headers: {
                                    'Authorization': `Bearer ${token}`
                                }
                            });
                        dispatch(authActions.updateWallet(resp.data.data.wallet))
                        window.ReactNativeWebView &&
                            window.ReactNativeWebView.postMessage(JSON.stringify(resp.data));
                        alertMsg(resp.data.message, 'success')
                        console.log("🚀 ~ file: PaymentModal.jsx:53 ~ .then ~ resp:", resp)
                        resolve(resp)
                    }
                    catch (err) {
                        window.ReactNativeWebView &&
                            window.ReactNativeWebView.postMessage(JSON.stringify(err.response));
                        console.error("🚀 ~ file: PaymentModal.jsx:56 ~ .then ~ err:", err)
                        onError(err)
                        reject(err)
                    }
                })

                // call server-side endpoint to finish the sale
            });
    }

    return (
        <>

            {
                isPending && <Box sx={{ textAlign: 'center' }}>
                    <Typography>Please wait while we process your payment...</Typography>
                    <CircularProgress className="" sx={{ mt: 1, width: "25px !important", height: "25px !important", }} />
                </Box>
            }
            <BraintreePayPalButtons
                style={style}
                disabled={false}
                fundingSource="" // Available values are: ["paypal", "card", "credit", "paylater", "venmo"]
                forceReRender={[style, amount]}
                createOrder={createOrder}
                onApprove={onApproveHandler}
                onError={console.error}
            />
        </>
    );
};

const Timer = ({ endTime, onTimerComplete }) => {
    const [seconds, setSeconds] = useState(0)
    useEffect(() => {
        const timer = setInterval(() => {
            setSeconds(prev => {
                const diff = moment(endTime).diff(moment(), 'seconds')
                if (diff < 1) {
                    clearInterval(timer)
                    onTimerComplete && onTimerComplete()
                    return false
                }
                return diff
            })
        }, 500)
        return () => {
            clearInterval(timer)
        }
    }, [])
    return (!!seconds && <Typography> {seconds} seconds to complete payment</Typography>)
}

const MobilePayment = () => {
    const theme = useTheme()
    const [clientToken, setClientToken] = useState(false)
    const dispatch = useDispatch()
    const { user } = useAuth()
    const axios = useAxiosPrivate()
    const [searchParams, setSearchParams] = useSearchParams()
    const paymentToken = searchParams.get('paymenttoken')
    const [paymentAmount, setPaymentAmount] = useState(0)
    const [isPaymentError, setIsPaymentError] = useState(false)
    const [expiresAt, setExpiresAt] = useState(false)

    const getClientToken = async () => {
        try {
            const resp = await axios.get('payments/client_token/', {
                withCredentials: true,
                headers: {
                    'Authorization': `Bearer ${paymentToken}`
                }
            })
            setExpiresAt(resp.data.data.expires_at)
            setClientToken(resp.data.data.client_token)
            dispatch(authActions.grantLoginAccess({
                accessToken: paymentToken,
                user: { ...resp.data.data.user },
                isLoggedIn: true
            }));
            console.log("🚀 ~ file: MobilePayment.jsx:117 ~ getClientToken ~  resp.data.data.amount > 0 :", resp.data.data.amount > 0)
            setPaymentAmount(resp.data.data.amount)
        }
        catch (err) {
            setIsPaymentError(true)
            window.ReactNativeWebView &&
                window.ReactNativeWebView.postMessage(JSON.stringify(err.response));
            console.error("🚀 ~ file: PaymentModal.jsx:34 ~ getClientToken ~ err:", err)
        }
    }

    useEffect(() => {
        getClientToken()
        return () => {
        }
    }, [])

    return (

        <Box>
            {
                isPaymentError ?
                    <Box sx={{ height: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <Box>
                            <Alert severity="error">
                                <AlertTitle>Payment Failed!</AlertTitle>
                                If amount was debited you'll get a refund.
                            </Alert>
                        </Box>
                    </Box>
                    :
                    user.wallet &&
                    <Box sx={{ height: "100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", px: 2 }}>
                        <Box sx={{ textAlign: "center" }}>
                            <Typography sx={{ fontSize: { xs: 20, xl: 22 }, color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}> Wallet recharge of ${paymentAmount}</Typography>
                        </Box>
                        <Box sx={{ textAlign: "center", pt: 2, mb: 4 }}>
                            <Typography variant='span' sx={{ fontSize: { xs: '16px', md: "18px" }, color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>Current balance : $</Typography>
                            <Typography variant='span' sx={{ fontSize: { xs: '16px', md: "18px" }, color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>{user.wallet.wallet_amount}</Typography>
                        </Box>
                        <Box className="payment-paypal-resp">
                            <Box>
                                {
                                    paymentAmount > 0 &&
                                    (
                                        clientToken
                                            ?
                                            <PayPalScriptProvider
                                                options={{
                                                    "data-client-token": clientToken,
                                                    "client-id": PAYPAL_CLIENT_KEY,
                                                    components: "buttons",
                                                    intent: "capture",
                                                    vault: false,
                                                }}
                                            >
                                                {
                                                    expiresAt && <Box sx={{ textAlign: 'center', mb: 2 }}>
                                                        <Timer onTimerComplete={() => { setIsPaymentError(true)}} endTime={expiresAt} />
                                                    </Box>
                                                }
                                                <Box className="payment-paypal">
                                                    <ButtonWrapper currency={"USD"} token={paymentToken} paymentAmount={paymentAmount} onError={() => { setIsPaymentError(true) }} />
                                                </Box>
                                            </PayPalScriptProvider>
                                            :
                                            <Grid container spacing={{ xs: 2, mt: 1, mb: 3 }}>
                                                <Grid item xs={12}>
                                                    <Box sx={{ height: "100px", display: "flex", alignItems: "center", justifyContent: "center", background: "#ebecf0", borderRadius: "6px" }}>
                                                        <CircularProgress />
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                    )
                                }
                            </Box>
                        </Box>
                    </Box>
            }
        </Box>

    )
}

export default MobilePayment